import {
  all,
  call,
  put,
  select,
} from 'redux-saga/effects';
import { get, getData } from '../services/api';
import {
  breedMultibrandValidationFailed,
  breedMultibrandValidationSucceed,
  orcaGetPowerUpAttempt,
  orcaGetPowerUpBatchItemAttempt,
  orcaGetPowerUpBatchItemFailed,
  orcaGetPowerUpBatchItemLoaded,
  orcaGetPowerUpFailed,
  orcaGetPowerUpLoaded,
} from '../actions';
import { API_TOKEN, WEBVIEW_API_TOKEN } from '../services/constants';
import {
  usePetCloudPolicyV1T172596ForSagas,
} from '../services/featureFlagsForSagas';

export function* getOrcaPowerUp(dispatch, { payload }) {
  const { productKey } = payload;

  try {
    yield put(orcaGetPowerUpAttempt({ productKey }));

    const getPublished = process.env.REACT_APP_NAME === 'Prod';
    const url =
      `policy/Contentful/GetPowerDetails/${productKey}/${getPublished}`;

    const response = yield call(get, dispatch, url);

    if (response.success && response.IsValid && response.Data) {
      yield put(orcaGetPowerUpLoaded({ data: response.Data, productKey }));
    } else {
      yield put(orcaGetPowerUpFailed({ productKey }));
    }
  } catch (e) {
    yield put(orcaGetPowerUpFailed({ productKey }));
  }
}

export function* getOrcaPowerUpBatchItem(dispatch, { payload }) {
  const { productKey } = payload;

  try {
    yield put(orcaGetPowerUpBatchItemAttempt({ productKey }));

    const getPublished = process.env.REACT_APP_NAME === 'Prod';
    const url =
      `policy/Contentful/GetPowerDetails/${productKey}/${getPublished}`;

    const response = yield call(get, dispatch, url);

    if (response.success && response.IsValid && response.Data) {
      yield put(orcaGetPowerUpBatchItemLoaded({
        data: response.Data,
        productKey,
      }));
    } else {
      yield put(orcaGetPowerUpBatchItemFailed({ productKey }));
    }
  } catch (e) {
    yield put(orcaGetPowerUpBatchItemFailed({ productKey }));
  }
}

export function* getOrcaPowerUpsBatch(dispatch, { payload }) {
  const { productKeys } = payload;
  const powerUpDetailsByKey = yield select(
    (state) => state.orcaInsurance.powerUpDetailsByKey,
  );

  const pendingKeys = productKeys
    .filter((productKey) => productKey
      && !powerUpDetailsByKey[productKey]?.data
      && !powerUpDetailsByKey[productKey]?.loading);

  yield all(pendingKeys.map((productKey) => call(
    getOrcaPowerUpBatchItem,
    dispatch,
    { payload: { productKey } },
  )));
}

export function* validateBreedMultibrand(dispatch, { payload }) {
  try {
    const { petId } = payload;
    // Validate orca double active policies
    const url = 'api/Orca/Customer/HasMultiplePolicies';
    // get webview list information
    const webViewToken = getData(WEBVIEW_API_TOKEN) || getData(API_TOKEN);
    const query = { token: webViewToken };
    const isPolicyApi = yield usePetCloudPolicyV1T172596ForSagas();
    const api = isPolicyApi ? 'policy' : 'api';
    const webviewsData = `${api}/MultiBrand/GetQuoteUrls/${petId}`;

    const [response, respWebviewsData] = yield all([
      call(get, dispatch, url),
      call(get, dispatch, webviewsData, query),
    ]);

    if (response.success
      && response.IsValid
      && respWebviewsData.success
      && respWebviewsData.IsValid
    ) {
      dispatch(breedMultibrandValidationSucceed({
        hasMultipleOrcaPolicies: response.Data.HasMultipleOrcaPolicies,
        policyProvider: response.Data.PolicyProvider,
        webviewsData: respWebviewsData.Data,
      }));
    } else {
      dispatch(breedMultibrandValidationFailed());
    }
  } catch (e) {
    dispatch(breedMultibrandValidationFailed());
  }
}
